/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Status_BadgeInputs */

const vi_await_status_badge = /** @type {(inputs: Await_Status_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ đóng gói`)
};

/**

* @param {Await_Status_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_status_badge = /** @type {((inputs?: Await_Status_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Status_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_status_badge(inputs)
});